import { useMemo } from 'react';

import { selectors, useAppSelector } from 'state/global-state';
import { useOffersContext } from 'state/offers';

export const useRewardQuantity = () => {
  const appliedOffers = useAppSelector(selectors.loyalty.selectAppliedOffers);
  const offer = useOffersContext();

  return useMemo(() => {
    const legacyOfferQuantity: number = offer.selectedOfferCartEntry ? 1 : 0;
    const offerQuantity: number = appliedOffers?.length || 0;

    return offerQuantity + legacyOfferQuantity;
  }, [appliedOffers, offer.selectedOfferCartEntry]);
};
